import React, { Fragment, useEffect, useState } from "react";
import { profileSeriesColumn } from "Constants/TableColumns";
import Radio from "@material-ui/core/Radio";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getAllSeriesByCountry } from "Stores/actions";
import {ReactSVG} from "react-svg";
import checkBoxCheckIcon from "Assets/svg/icon/checkBoxCheckIcon.svg";
import checkedBoxIcon from "Assets/svg/icon/checkedBoxIcon.svg";
import Translator from "Languages/Utility/Translator";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function SeriesProfileTable({
  data,
  onSelect,
  selected,
  idCountry,
  idStruct,
  idpop,
  idBrand,
  nameSearch,
  limit
}) {
  const { profileTblDataPagination } = useSelector((state) => ({
    profileTblDataPagination: state.profile.profileTblDataPagination,
  }));
  const [sizePerPage, setSizePerPage] = useState(limit);//useState(profileTblDataPagination.Limit);
  const [currentPage, setCurrentPage] = useState(profileTblDataPagination.Page);
  const [tblData, setTblData] = useState(data);
  const [total, setTotal] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setTblData(data);
    setTotal(profileTblDataPagination.Total);
  }, [data, profileTblDataPagination]);

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    onSelect: (row) => onSelect(row),
    selected: selected,
    classes: "selection-row",
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <Radio
          className="selectRadio"
          checked={checked}
          disabled={disabled}
          color="default"
          // size="small"
          // checkedIcon={<ReactSVG src={checkBoxCheckIcon} />}
          // icon={<ReactSVG src={checkedBoxIcon} />}
        />
      );
    },
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    try {
      setLoading(true);
      const paramsSeries = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdBrand: idBrand?.value,
        Idpop: idpop,
        IdStruct: idStruct,
        Limit: sizePerPage,
        Page: page,
        IdCountry: idCountry,
        Name: nameSearch,
      };
      await dispatch(getAllSeriesByCountry(paramsSeries));
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <RemoteTable
        selectRow={selectRow}
        data={tblData}
        keyField="num"
        columns={profileSeriesColumn}
        loading={loading}
        page={currentPage}
        sizePerPage={sizePerPage}
        sizePerPageList={[{
          text: sizePerPage.toString(),
          value: sizePerPage
        }]}
        totalSize={total}
        onTableChange={onTableChange}
        title={<Translator id='SeriProfile'/>}
      />
    </Fragment>
  );
}

export default SeriesProfileTable;
